const permissions = {
	title: "Permissions",
	new_permission: "New Permission",
	edit_permission: "Edit Permission: {name}",
	list_title: "List of Permissions",
	list_subtitle: "Manage permissions",
	create_title: "Create New Permission",
	update_title: "Update Permission",
	detail_title: "Permission Details",
	id: "ID",
	name: "Name",
	module: "Module",
};
export default permissions;